var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2857 0H1.71429C0.7675 0 0 0.7675 0 1.71429V14.2857C0 15.2325 0.7675 16 1.71429 16H14.2857C15.2325 16 16 15.2325 16 14.2857V1.71429C16 0.7675 15.2325 0 14.2857 0ZM3.35714 13.7143C3.10596 13.7143 2.89082 13.5403 2.83514 13.299L2.2995 10.9776C2.27125 10.8552 2.28692 10.7268 2.34376 10.6147C2.4006 10.5027 2.495 10.4142 2.61046 10.3648L5.11039 9.29336C5.21718 9.24759 5.33596 9.23779 5.44881 9.26542C5.56166 9.29305 5.66247 9.35661 5.73604 9.44654L6.84307 10.7996C8.59107 9.97946 9.99654 8.55464 10.7995 6.84314L9.44646 5.73611C9.35655 5.66253 9.29298 5.56172 9.26535 5.44888C9.23772 5.33603 9.24753 5.21726 9.29329 5.11046L10.3647 2.61054C10.4142 2.49507 10.5027 2.40067 10.6147 2.34383C10.7267 2.28699 10.8552 2.27133 10.9776 2.29957L13.299 2.83521C13.417 2.86243 13.5224 2.92885 13.5978 3.02365C13.6732 3.11844 13.7143 3.236 13.7143 3.35714C13.7143 9.08186 9.07339 13.7143 3.35714 13.7143Z",
    fill: "#204FB0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneBlue);
export default __webpack_public_path__ + "static/media/phoneBlue.f735620be8ac162ecac68f11c682d366.svg";
export { ForwardRef as ReactComponent };